export default function EditorNotes({
  value,
  onChange,
}: {
  value: string;
  onChange: (value: string) => void;
}) {
  return (
    <div className="flex flex-col gap-3">
      <p className="font-medium">Notes for the editors</p>
      <textarea
        value={value}
        onChange={(event) => onChange(event.target.value)}
        placeholder="Anything our editors should know while creating your videos?"
        className="min-h-24 w-full rounded-md border border-input bg-background px-3 py-2 text-sm outline-none focus:border-tertiary-400 focus:ring-1 focus:ring-tertiary-400"
      />
    </div>
  );
}
